import React from 'react';
import FlatButton from 'material-ui/FlatButton';
import clipBoardImage from 'assets/tasks-clipboard.svg';
import { getTranslatedString } from 'helpers/i18n';
import { AccentColor } from 'helpers/AccentColorHelper';
import { colors } from 'helpers/ColorHelper';

import styled from 'styled-components';
import { RenderIfToggleOn, RenderIfToggleOff } from 'components/shared/ToggleRenderer';
import CtaPrimary from 'components/ui/CtaPrimary';

const NoTasks = props => {
  const { disabled, editable, click } = props;
  return (
    <React.Fragment>
      <RenderIfToggleOff toggle="ui.maintenance.new_tickets_ui">
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <img
            src={clipBoardImage}
            alt="Clipboard Icon"
            style={{ marginTop: '15px', height: '140px' }}
          />
          <p
            style={{
              fontSize: 'larger',
              fontWeight: 'bold',
              marginBottom: '15px',
              marginTop: '10px',
            }}
          >
            {getTranslatedString('landlordPortal.taskList.noTask')}
          </p>

          {editable && (
            <div className="row" style={{ textAlign: 'center', marginBottom: '15px' }}>
              <FlatButton
                label={getTranslatedString('landlordPortal.taskList.addTask')}
                type="button"
                backgroundColor={disabled ? colors.LIGHT_GRAY : AccentColor()}
                hoverColor="grey"
                style={{ color: 'white' }}
                disabled={disabled}
                onClick={click}
              />
            </div>
          )}
        </div>
      </RenderIfToggleOff>
      <RenderIfToggleOn toggle="ui.maintenance.new_tickets_ui">
        <NewNoTask click={click} disabled={disabled} />
      </RenderIfToggleOn>
    </React.Fragment>
  );
};

export default NoTasks;

const StyledNoTaskContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 12px;
  padding: 40px;
  background-color: white;
`;

const NewNoTask = ({ click, disabled }) => {
  return (
    <StyledNoTaskContainer>
      <p
        style={{
          fontSize: 'larger',
          fontWeight: 'bold',
          margin: '0px',
        }}
      >
        {getTranslatedString('landlordPortal.taskList.youDontHaveTasks')}
      </p>
      <p
        style={{
          fontSize: 'larger',
          marginBottom: '24px',
          color: colors.CHAR_COUNT,
        }}
      >
        {getTranslatedString('landlordPortal.taskList.yay')}
      </p>
      <CtaPrimary
        type="button"
        onClick={click}
        contentKey="landlordPortal.taskList.add"
        disabled={disabled}
      >
        {getTranslatedString('landlordPortal.taskList.addTask')}
      </CtaPrimary>
    </StyledNoTaskContainer>
  );
};
